<template>
  <div 
    class="UiSkeleton bg-gray-200 rounded animate-pulse" 
    :style='componentstyle'
  ></div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    type: {
      
    },
    width: 100,
    height: 100
  },
  computed: {
    componentstyle() {
      return `width : ${this.width}%; height : ${this.height}vh`
    }
  }
}
</script>

<style lang="scss" scoped>
.UiSkeleton {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  50% {
    opacity: .5
  }
}

</style>
